(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/taggedTemplateLiteralLoose', 'babel-runtime/helpers/extends', 'react', 'react-emotion', '@material-ui/icons/ChevronLeft', '@material-ui/icons/ChevronRight', '@material-ui/icons/Close', '@material-ui/icons/HelpOutline', '@material-ui/icons/HighlightOff', '@material-ui/icons/List', '@material-ui/icons/Message', '@material-ui/icons/MoreHoriz', '@material-ui/icons/Note', '@material-ui/icons/RemoveCircleOutline', '@material-ui/icons/Check', '../styles'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/taggedTemplateLiteralLoose'), require('babel-runtime/helpers/extends'), require('react'), require('react-emotion'), require('@material-ui/icons/ChevronLeft'), require('@material-ui/icons/ChevronRight'), require('@material-ui/icons/Close'), require('@material-ui/icons/HelpOutline'), require('@material-ui/icons/HighlightOff'), require('@material-ui/icons/List'), require('@material-ui/icons/Message'), require('@material-ui/icons/MoreHoriz'), require('@material-ui/icons/Note'), require('@material-ui/icons/RemoveCircleOutline'), require('@material-ui/icons/Check'), require('../styles'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.taggedTemplateLiteralLoose, global._extends, global.react, global.reactEmotion, global.ChevronLeft, global.ChevronRight, global.Close, global.HelpOutline, global.HighlightOff, global.List, global.Message, global.MoreHoriz, global.Note, global.RemoveCircleOutline, global.Check, global.styles);
    global.MaterialIcon = mod.exports;
  }
})(this, function (exports, _taggedTemplateLiteralLoose2, _extends2, _react, _reactEmotion, _ChevronLeft, _ChevronRight, _Close, _HelpOutline, _HighlightOff, _List, _Message, _MoreHoriz, _Note, _RemoveCircleOutline, _Check, _styles) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);

  var _extends3 = _interopRequireDefault(_extends2);

  var React = _interopRequireWildcard(_react);

  var _ChevronLeft2 = _interopRequireDefault(_ChevronLeft);

  var _ChevronRight2 = _interopRequireDefault(_ChevronRight);

  var _Close2 = _interopRequireDefault(_Close);

  var _HelpOutline2 = _interopRequireDefault(_HelpOutline);

  var _HighlightOff2 = _interopRequireDefault(_HighlightOff);

  var _List2 = _interopRequireDefault(_List);

  var _Message2 = _interopRequireDefault(_Message);

  var _MoreHoriz2 = _interopRequireDefault(_MoreHoriz);

  var _Note2 = _interopRequireDefault(_Note);

  var _RemoveCircleOutline2 = _interopRequireDefault(_RemoveCircleOutline);

  var _Check2 = _interopRequireDefault(_Check);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(['\n    font-size: 1rem;\n  '], ['\n    font-size: 1rem;\n  ']);

  var ICONS = {
    chevron_left: _ChevronLeft2.default,
    chevron_right: _ChevronRight2.default,
    close: _Close2.default,
    help_outline: _HelpOutline2.default,
    highlight_off: _HighlightOff2.default,
    list: _List2.default,
    message: _Message2.default,
    more_horiz: _MoreHoriz2.default,
    note: _Note2.default,
    remove_circle_outline: _RemoveCircleOutline2.default,
    check: _Check2.default
  };

  // NOTE: change size by providing fontSize in the className or style prop
  var MaterialIcon = function MaterialIcon(_ref) {
    var name = _ref.name,
        color = _ref.color,
        style = _ref.style,
        className = _ref.className;

    var Icon = ICONS[name];
    return React.createElement(
      'span',
      {
        className: (0, _reactEmotion.cx)(classNames.icon, className),
        style: (0, _extends3.default)({}, style, { color: color }),
        'aria-hidden': true
      },
      React.createElement(Icon, { fontSize: 'inherit', color: 'inherit' })
    );
  };

  MaterialIcon.defaultProps = {
    color: _styles.colors.prussian
  };

  var classNames = {
    icon: (0, _reactEmotion.css)(_templateObject)
  };

  exports.default = MaterialIcon;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/elements/MaterialIcon.js
// module id = 518
// module chunks = 0